export const Landing = ({ titleText1, titleText2, paragraphText }) => {

    const scroll = (e) => {
        e.preventDefault();
        window.scrollTo({
            top: document.querySelector("#introduction").offsetTop,
            behavior: "smooth",
        })
    }

    return (
        <section id='landing'>
            <div id='landing-background'></div>
            <div className='grid'>
                <h1>VOG:<br />{titleText1}<br />{titleText2}</h1>
                <div id='landingParagraphText' className='miniTitleText'><p>{paragraphText}</p></div>
                <div id='goDown' onClick={scroll}><span>↓</span></div>
            </div>
        </section>
    );
}